<div class="hemro-vertical-navigation-wrapper">

  <!-- Header -->
  <div class="hemro-vertical-navigation-header">
    <ng-content select="[hemroVerticalNavigationHeader]"></ng-content>
  </div>

  <!-- Content -->
  <div
    class="hemro-vertical-navigation-content"
    hemroScrollbar
    [hemroScrollbarOptions]="{wheelPropagation: inner, suppressScrollX: true}"
    #navigationContent>

    <!-- Content header -->
    <div class="hemro-vertical-navigation-content-header">
      <ng-content select="[hemroVerticalNavigationContentHeader]"></ng-content>
    </div>

    <!-- Items -->
    @for (item of navigation; track trackByFn($index, item)) {
      <!-- Skip the hidden items -->
      @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
        <!-- Aside -->
        @if (item.type === 'aside') {
          <hemro-vertical-navigation-aside-item
            [item]="item"
            [name]="name"
            [activeItemId]="activeAsideItemId"
            [autoCollapse]="autoCollapse"
            [skipChildren]="true"
          (click)="toggleAside(item)"></hemro-vertical-navigation-aside-item>
        }
        <!-- Basic -->
        @if (item.type === 'basic') {
          <hemro-vertical-navigation-basic-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-basic-item>
        }
        <!-- Collapsable -->
        @if (item.type === 'collapsable') {
          <hemro-vertical-navigation-collapsable-item
            [item]="item"
            [name]="name"
          [autoCollapse]="autoCollapse"></hemro-vertical-navigation-collapsable-item>
        }
        <!-- Divider -->
        @if (item.type === 'divider') {
          <hemro-vertical-navigation-divider-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-divider-item>
        }
        <!-- Group -->
        @if (item.type === 'group') {
          <hemro-vertical-navigation-group-item
            [item]="item"
            [name]="name"
          [autoCollapse]="autoCollapse"></hemro-vertical-navigation-group-item>
        }
        <!-- Spacer -->
        @if (item.type === 'spacer') {
          <hemro-vertical-navigation-spacer-item
            [item]="item"
          [name]="name"></hemro-vertical-navigation-spacer-item>
        }
      }
    }

    <!-- Content footer -->
    <div class="hemro-vertical-navigation-content-footer">
      <ng-content select="[hemroVerticalNavigationContentFooter]"></ng-content>
    </div>

  </div>

  <!-- Footer -->
  <div class="hemro-vertical-navigation-footer">
    <ng-content select="[hemroVerticalNavigationFooter]"></ng-content>
  </div>

</div>

<!-- Aside -->
@if (activeAsideItemId) {
  <div
    class="hemro-vertical-navigation-aside-wrapper"
    hemroScrollbar
    [hemroScrollbarOptions]="{wheelPropagation: false, suppressScrollX: true}"
    [@fadeInLeft]="position === 'left'"
    [@fadeInRight]="position === 'right'"
    [@fadeOutLeft]="position === 'left'"
    [@fadeOutRight]="position === 'right'">
    <!-- Items -->
    @for (item of navigation; track trackByFn($index, item)) {
      <!-- Skip the hidden items -->
      @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
        <!-- Aside -->
        @if (item.type === 'aside' && item.id === activeAsideItemId) {
          <hemro-vertical-navigation-aside-item
            [item]="item"
            [name]="name"
          [autoCollapse]="autoCollapse"></hemro-vertical-navigation-aside-item>
        }
      }
    }
  </div>
}
